<template lang="pug">
.result
  h3.result-title.d-flex.justify-content-between
    span ส่วนที่ 3 : ทักษะทางภาษาและทักษะพิเศษอื่นๆ
    span(@click='$store.commit("SET_STEP", 3)', role='button') แก้ไข
  .language-skills
    table(v-if='skills.language')
      thead
        tr
          th ภาษา
          th ฟัง/Listening
          th พูด/Speaking
          th อ่าน/Reading
          th เขียน/Writing
      tbody
        tr(v-for='(skill, index) in skills.language')
          td {{ skill.title }}
          td {{ skill.listening }}
          td {{ skill.reading }}
          td {{ skill.writing }}

    h4.result-subtitle ทักษะพิเศษอื่นๆ (Special Abilities)

    .row.result-item
      strong.col-sm-5 1.ท่านมีใบอนุญาติขับขี่หรือไม่
      span
        template(v-if='skills.driver_license') 
          div(v-for='(item, index) in skills.driver_license', :key='index') {{ item }}
        template(v-else) -

    .row.result-item
      strong.col-sm-5 2.ความสามารถทางคอมพิวเตอร์ / Computer Skills
      span
        template(v-if='skills.computer') {{ skills.computer }}
        template(v-else) -

    .row.result-item
      strong.col-sm-5 3.งานอดิเรก / กิจกรรมที่สนใจ Hobbies
      span
        template(v-if='skills.hobbies') {{ skills.hobbies }}
        template(v-else) -
    .row.result-item
      strong.col-sm-5 4.ความชำนาญด้านอื่น / Additional Skills
      span
        template(v-if='skills.additional') {{ skills.additional }}
        template(v-else) -
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['skills']),
  },
}
</script>

<style lang="scss" scoped>
.language {
  &-skills {
    .form-control {
      max-width: 12rem;
      margin: 0 auto;
      text-align: center;
    }

    table {
      width: 100%;
      margin-bottom: 4rem;
      text-align: center;
      border: solid 1px #d1d3d4;

      td {
        position: relative;
        padding: 0.75rem 1rem;
        border-left: solid 1px #d1d3d4;
        // border-bottom: solid 1px #d1d3d4;
      }

      tfoot {
        td {
          border-top: solid 1px #d1d3d4;
        }
      }

      tbody {
        tr:first-child {
          td {
            padding-top: 2rem;
          }
        }

        tr:last-child {
          td {
            padding-bottom: 2rem;
          }
        }
      }

      th {
        text-align: center;
        color: #fff;
        font-size: 20px;
        padding: 1rem 0;
        background: #67c3e9;
        border: solid 1px #59b6dc;

        &:first-child {
          width: 30%;
        }
      }
    }
  }
}
</style>
